import { getTripleID } from "./common"
export const trackBreadcrumbClick = breadcrumbName => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "breadcrumb_click",
      breadcrumb: breadcrumbName,
      ...getTripleID()
    })
  }
}
